<div>
    <div class="modal-header">
        <h5 class="mb-0">{{ title | translate }}</h5>
    </div>
    <div class="modal-body">
        <p class="mb-3" *ngIf="item?.elapsedMilliseconds > 0">{{ 'notification.result_elapsed_time' | translate: { elapsedMilliseconds: item?.elapsedMilliseconds, allCount: item?.allUserCount } }}</p>
        <form class="k-form k-form-md" [formGroup]="form">
            <div class="mb-1 row">
                <div class="col-12 col-md-4 col-xl-4">
                    <app-label controlName="allUserCount" class="col-form-label">{{ 'notification.result_all_count' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <input type="text" id="allUserCount" formControlName="allUserCount" class="form-control" />
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-4 col-xl-4">
                    <app-label controlName="messageDeliveryStatus" class="col-form-label">{{ 'notification.result_message_delivery_status' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <input type="text" id="messageDeliveryStatus" class="form-control fw-bold" [ngClass]="messageDeliveryStatusClass" [value]="item?.messageDeliveryStatusTranslateKey | translate" disabled />
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-4 col-xl-4">
                    <app-label controlName="details" class="col-form-label">{{ 'notification.result_details' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered align-middle mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th>{{ 'notification.message_sent_type_title' | translate }}</th>
                                    <th class="text-center">{{ 'notification.result_success_count' | translate }}</th>
                                    <th class="text-center">{{ 'notification.result_disabled_in_the_app_count' | translate }}</th>
                                    <th *ngIf="!isEmailResult" class="text-center">
                                        {{ 'notification.result_invalid_fcm_token_count' | translate }}
                                        <i class="fa-solid fa-circle-info ms-1 text-muted" [tooltip]="'notification.result_invalid_fcm_token_tooltip' | translate" placement="top"></i>
                                    </th>
                                    <th class="text-center">{{ 'notification.result_error_count' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let result of item?.messageSentTypeResults">
                                    <td>{{ result.translateKey | translate }}</td>
                                    <td class="text-center">{{ result.successCount }}</td>
                                    <td class="text-center">{{ getCellValue(result, 'disabledInTheAppCount') }}</td>
                                    <td *ngIf="!isEmailResult" class="text-center">{{ getCellValue(result, 'invalidFCMTokenCount') }}</td>
                                    <td class="text-center" [class.text-danger]="result.errorCount > 0">{{ result.errorCount }}</td>
                                </tr>
                            </tbody>
                            <tfoot class="table-light fw-bold">
                                <tr>
                                    <td>{{ 'notification.result_total' | translate }}</td>
                                    <td class="text-center">{{ item?.successCount }}</td>
                                    <td class="text-center">{{ getTotalValue('disabledInTheAppCount') }}</td>
                                    <td *ngIf="!isEmailResult" class="text-center">{{ getTotalValue('invalidFCMTokenCount') }}</td>
                                    <td class="text-center" [class.text-danger]="item?.errorCount > 0">{{ item?.errorCount }}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="mb-1 row" *ngIf="!isEmailResult">
                <div class="col-12 col-md-4 col-xl-4">
                    <app-label controlName="sentCount" class="col-form-label">{{ 'notification.result_sent' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <input type="text" id="sentCount" formControlName="sentCount" class="form-control fw-bold" />
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-4 col-xl-4">
                    <app-label controlName="fullyDelivered" class="col-form-label">{{ 'notification.result_fully_delivered' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <input type="text" id="fullyDelivered" formControlName="fullyDelivered" class="form-control fw-bold" />
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-4 col-xl-4">
                    <app-label controlName="errors" class="col-form-label">{{ 'notification.result_errors' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <textarea id="errors" formControlName="errors" class="form-control font-monospace small" rows="8"></textarea>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="onClose(bsModalRef)">{{ 'common.close' | translate }}</button>
    </div>
</div>
